<template>
    <div class="page-select">
        <div class="pages-content">
            <div v-for="item in menus" class="pages" :key="item.id" @click="goTo(item.title,item.url,item.type)">
                <p>
                    <span>{{item.title}}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import apis from "../http/api";
    import commonApi from "../utils/commonapi";

    export default {
        name: "PageSelect",
        data() {
            return {
                menus: []
            }
        },
        created() {
            this.getMenu()
        },
        methods: {
            getMenu() {
                apis.user_permission().then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        // const arr = [
                        // {
                        //   id: 9,
                        //   title: 'IM消息',
                        //   type: 0,
                        //   url: '/message'
                        // },{
                        //   id: 10,
                        //   title: '学校活动',
                        //   type: 0,
                        //   url: '/activity'
                        // },
                        // ]
                        // }]
                        // this.menus = data.menus.concat(arr)
                        const arr = [
                            // {
                            //     id: 100,
                            //     title: '商店管理',
                            //     type: 0,
                            //     url: '/shop'
                            // }
                        ]
                        this.menus = data.menus.concat(arr)
                        // 存储路由用于路由拦截
                        localStorage.setItem('menus',JSON.stringify(data.menus))
                        // this.menus = data.menus
                    } else {
                        alert(msg)
                    }
                }).catch()
            },
            goTo(title, url, type) {
                // console.log(url, type)
                // 记录-点击入口
                commonApi.recordFromMenu(title,url)
                if (type === 1) {
                    window.open(url, '_self')
                } else {
                    if (!url) {
                        alert('加班开发中...')
                        return
                    }
                    this.$router.push(url);
                }
            }
        },
    }
</script>

<style scoped>
    .page-select {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 100vh;
    }

    .pages-content {
        width: 40vw;
        height: 40vw;
        display: flex;
        align-content: flex-start;
        flex-wrap: wrap;
    }

    .pages {
        width: 22%;
        height: 22%;
        background-color: #aeabb0;
        margin: 10px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        cursor: pointer;
    }

    .pages p {
        align-self: center;
    }

    .pages span {
        font-weight: bold;
        /* font-size: medium; */
    }
</style>